export default __webpack_public_path__ + "static/media/referral-program.2ca069b8.svg";